import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import http from '../services/httpService';
import useIsMounted from './useIsMounted';

export default function useGoProResult() {
	const [goProResult, setGoProResult] = useState(null);
	const { pathname } = useLocation();
	const isMounted = useIsMounted();

	useEffect(() => {
		const allowed = ['/dashboard/bonus/gopro1', '/dashboard/bonus/goPro1'];
		async function getGoProResult() {
			try {
				if (
					!http.getCurrentUser() ||
					goProResult ||
					!allowed.includes(pathname)
				)
					return;
				const { data } = await http.getGoProResult();
				if (isMounted()) setGoProResult(data);
			} catch (error) {
				console.log('error :>> ', error);
			}
		}
		getGoProResult();
	}, [isMounted, goProResult, pathname]);
	return [goProResult, setGoProResult];
}
